module.exports = __webpack_public_path__ + "img/btn-red-bg-s.65142a09.png";